import { useEffect } from 'react';
import cryptoJS from 'crypto-js';
import UtagHelper from 'utilities/utagHelper';
import { formatText } from 'core/i18n';
import { recordPageError } from 'utilities/uTagging';

export const useRecordPageError = ({ errorState, userProfile, defaultContent }) => {
    useEffect(() => {
        const { errorCode, errorNumber, pageName, errorMessage, errorCategory } = errorState;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

        recordPageError({
            pageName,
            description: formatText(errorMessage ?? defaultContent),
            onboardingHolderType: JointHolderInfo.typeHolder === 'primer titular' ? 'firstTitular' : 'secondTitular',
            investmentType: userProfile.investmentType,
            identificadorOnboarding: docNumberEncrypted,
            errorStatus: errorCode,
            errorNumber,
            errorCategory,
        });
        // eslint-disable-next-line
    }, []);
};
